var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-update-log',{attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }